import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af682c02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "img-container" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = { class: "button button-select" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Selecione uma imagem", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "trigger-area",
    id: "modal",
    role: "dialog",
    "aria-hidden": "true",
    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.closeCropper()), ["prevent"]))
  }, [
    _createElementVNode("div", {
      class: "modal-dialog",
      role: "document",
      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.closeCropper()), ["prevent"]))
          }, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              id: "image",
              src: _ctx.url,
              alt: "Picture",
              "data-user-image": ""
            }, null, 8, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("input", {
              type: "file",
              id: "image",
              "data-file": "",
              accept: ".png, .jpg, .jpeg, .webp",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setImageToPreview($event.target)))
            }, null, 32)
          ]),
          _createElementVNode("button", {
            class: "button button-add",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getCroppedImageUrl()))
          }, " Salvar ")
        ])
      ])
    ])
  ]))
}